import React, { memo } from 'react';
import block from 'bem-cn';
import isEqual from 'lodash.isequal';

import { PragmaticDGASweetBonanza } from 'components/slots/PragmaticDGA/hooks';

import { bubbleSuprise, candyDrop, container1, container2, container5, sugarBomb, sweetSpins } from './img';

import './SweetBonanza.scss';

const b = block('pragmatic-dga-sweet-bonanza');

type SweetBonanzaProps = {
  results: PragmaticDGASweetBonanza['gameResult']
};

const mapResultToBackgroundImage: Record<PragmaticDGASweetBonanza['gameResult'][number]['result'], string> = {
  1: container1,
  2: container2,
  5: container5,
  'Candy Drop': candyDrop,
  'Sweet Spins': sweetSpins,
  'Bubble Surprise': bubbleSuprise,
};

const textValues = ['1', '2', '5'];

export const SweetBonanza = memo(({ results }: SweetBonanzaProps) => (
  <div className={b()}>
    {results.map(({ result, sbmul }, index) => {
      const backgroundImage = mapResultToBackgroundImage[result];
      const isTextValue = textValues.includes(result);

      const valueContent = (
        <div
          key={index}
          className={b('result')}
          style={{ backgroundImage: `url(${backgroundImage})`}}
        >
          {isTextValue && (
            <span className={b('result-value')}>
              {result}
            </span>
          )}
        </div>
      );

      if (sbmul.length === 0) {
        return (
          <div className={b('result-container')} key={index}>
            {valueContent}
            {sbmul.reverse().map((_, mulIndex) => (
              <div
                key={mulIndex}
                className={b('result')}
                style={{ backgroundImage: `url(${sugarBomb})`}}
              />
            ))}
          </div>
        )
      }

      return valueContent;
    })}
  </div>
), isEqual);
